import { VisaReportDataInterface } from '../interfaces/visa-report-data.interface';

export class VisaReportData {
  /**
   * Project ID.
   */
  public projectId: number;

  /**
   * Category ID.
   */
  public categoryId: string;

  /**
   * Document ID.
   */
  public documentId: string;

  /**
   * Circuit ID.
   */
  public circuitId: string;

  /**
   * @param data Visa report data interface.
   */
  constructor(data: VisaReportDataInterface) {
    if (data) {
      this.projectId = data.projectId;
      this.categoryId = data.categoryId;
      this.documentId = data.documentId;
      this.circuitId = data.circuitId;
    }
  }
}
